import React from "react";
import { Container, Typography, Box, Grid } from "@mui/material";
import Surface from "_components/Surface";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { useRaces } from "hooks/useRaces";
import { useAuth } from "hooks/useAuth";
import RaceItem from "./_components/RaceItem";

function Dashboard() {
  const { races } = useRaces();
  const { user } = useAuth();

  return (
    <Container maxWidth={false}>
      <Box my={4}>
        {user && (
          <Typography variant="h5" gutterBottom>
            Bonjour {user?.displayName},
          </Typography>
        )}
        <Typography variant="h2" gutterBottom>
          Tableau de bord
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={9}>
          <Surface title={"Mes parcours"}>
            <Grid container spacing={3}>
              {/* Conteneur de la grille */}
              {races.map((race: any, index: any) => {
                return (
                  <Grid item xs={12} md={4} key={index}>
                    <RaceItem race={race} />
                  </Grid>
                );
              })}
            </Grid>
          </Surface>
        </Grid>
        <Grid
          alignContent={"flex-start"}
          spacing={3}
          container
          item
          xs={12}
          md={3}
        >
          <Grid item xs={12} md={12}>
            <Surface textAlign="center" title={"Pack de language"}>
              <HighlightOffRoundedIcon
                color="disabled"
                sx={{ fontSize: 150 }}
              />
            </Surface>
          </Grid>
          <Grid item xs={12} md={12}>
            <Surface textAlign="center" title={"Monétisation"}>
              <HighlightOffRoundedIcon
                color="disabled"
                sx={{ fontSize: 150 }}
              />
            </Surface>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Dashboard;
